var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 48 47",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#96de06" },
        attrs: {
          d: "M6.1-.1h35.8C45.3-.1 48 2.7 48 6v34.8c0 3.4-2.7 6.1-6.1 6.1H6.1C2.8 47 0 44.2 0 40.8V6.1C0 2.7 2.8-.1 6.1-.1z",
        },
      }),
      _c("defs", [
        _c("path", {
          attrs: {
            id: "a",
            d: "M6.2-.1H42c3.4 0 6.1 2.8 6.1 6.1v34.8c0 3.4-2.7 6.1-6.1 6.1H6.2c-3.4 0-6.1-2.8-6.1-6.1V6.1C.1 2.7 2.8-.1 6.2-.1z",
          },
        }),
      ]),
      _c("clipPath", { attrs: { id: "b" } }, [
        _c("use", {
          staticStyle: { overflow: "visible" },
          attrs: { "xlink:href": "#a" },
        }),
      ]),
      _c("path", {
        staticStyle: { "clip-path": "url(#b)", fill: "#c6fb31" },
        attrs: {
          d: "M20.7 13h27.5c2.2 0 4 1.8 4 4v29.2c0 2.2-1.8 4-4 4H20.7c-2.2 0-4-1.8-4-4V17c0-2.2 1.8-4 4-4z",
        },
      }),
      _c("path", {
        staticStyle: { "clip-path": "url(#b)", fill: "#a9ea27" },
        attrs: {
          d: "M31 24.1h19c2.2 0 4 1.8 4 4v20.3c0 2.2-1.8 4-4 4H31c-2.2 0-4-1.8-4-4V28.1c0-2.3 1.8-4 4-4z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }